<div class="audio-device-container">
  <h1 class="selection">Sélectionner un appareil</h1>
  <div *ngIf="audioDevices?.length === 0">
    <mat-spinner></mat-spinner>
  </div>
  <div class="device-selector">
    <div class="device-selector__checkbox">
      <div class="device-selector-content"
           *ngFor="let device of audioDevices.slice(0,2); let first = first"
           (click)="selectAudioDevice(device.id)"
           [style.color]="selectedAudioDeviceId === device.id ? '#FF5353' : '#403B3B'"
           [style.font-weight]="selectedAudioDeviceId === device.id ? 'bolder' : '400'">
        <img *ngIf="first" alt="sonos local" src="assets/icons/sonos-local.svg">
        <img *ngIf="!first" alt="sonos speaker" src="assets/icons/sonos-speaker.svg">
        <span class="device-name">
          {{ device.name }} - {{ device.type }}
        </span>
      </div>
    </div>
  </div>

</div>
